let React = require('react');
import TableRow from './TableRow.jsx';
import TableRowEdit from './TableRowEdit.jsx';
import TableRowItalic from './TableRowItalic.jsx';
import TableRowItalicEdit from './TableRowItalicEdit.jsx';

let TableBody = React.createClass({
    createRow(row, novedadCuenta, novedadCuentaEditado, empId, selId, editId, editadoId, editNotifyFn, listNovedadEditado) {
        let novedad = novedadCuenta.find(x => x.CuentaTarjetaId === row.Id);
        let flag = null;
        let flagEditado = null;
        let empresaVisaId = row.EmpresaId ? row.EmpresaId : row.EmpresaVisaId; 
        if (empresaVisaId == empId) {
            flagEditado = (row.Id == editadoId);

            if (row.Id == selId) {

                flag = (row.Id == editId);
                if (row.esNueva || novedad == undefined) {
                    return (
                        <TableRowEdit
                            row={row}
                            data={this.props.data}
                            novedad={novedad}
                            listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ACC_CRED_" + row.Id} editRow={flag} editNotifyFn={editNotifyFn}
                            comienzoDeEdicion={this.props.comienzoDeEdicion}
                            desaparicionLapizEdicion={this.props.desaparicionLapizEdicion}
                            cancelEdicionLimite={this.props.cancelEdicionLimite}
                            aceptarEdicion={this.props.aceptarEdicion}
                            mostrarMensajeLimitesIguales={this.props.mostrarMensajeLimitesIguales}
                            modificacionLimite={this.props.modificacionLimite} />
                    );
                } else {
                    return (
                        <TableRowItalicEdit
                            row={row}
                            data={this.props.data}
                            novedad={novedad}
                            listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ACC_CRED_" + row.Id} editRow={flag} editadoRow={flagEditado} editNotifyFn={editNotifyFn}
                            comienzoDeEdicion={this.props.comienzoDeEdicion}
                            desaparicionLapizEdicion={this.props.desaparicionLapizEdicion}
                            cancelEdicionNovedad={this.props.cancelEdicionNovedad}
                            aceptarEdicion={this.props.aceptarEdicion}
                            modificacionNovedad={this.props.modificacionNovedad}/>
                    );
                }
            }
            else {

                if (novedad === undefined) {
                    return (
                        <TableRow row={row} data={this.props.data} novedad={novedad} listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ACC_CRED_" + row.Id} aparicionLapizEdicion={this.props.aparicionLapizEdicion} />
                    );
                } else {
                    return (
                        <TableRowItalic row={row} data={this.props.data} novedad={novedad} listNovedadEditado={listNovedadEditado}
                            key={"LIMIT_DIST_ACC_CRED_" + row.Id} editRow={flag} editadoRow={flagEditado}
                            aparicionLapizEdicion={this.props.aparicionLapizEdicion}
                            muestraEditadoNovedad={this.props.muestraEditadoNovedad}
                            ocultaEditadoNovedad={this.props.ocultaEditadoNovedad} />
                    );
                }
            }
        }
    },

    render: function () {
        let editNotifyFn = this.props.editNotifyFn;
        let novedadCuentaEditado;
        let novedadCuenta;
        let listNovedadEditado;
        if (this.props.data.novedadesCuentas !== undefined) {
            novedadCuentaEditado = listNovedadEditado = this.props.data.novedadesCuentas;
            novedadCuenta = this.props.data.novedadesCuentas != undefined ? JSON.parse(JSON.stringify(this.props.data.novedadesCuentas)) : this.props.data.novedadesCuentas;
        } else {
            novedadCuenta = listNovedadEditado = this.props.data.novedadesCuentas != undefined ? JSON.parse(JSON.stringify(this.props.data.novedadesCuentas)) : this.props.data.novedadesCuentas;
            novedadCuentaEditado = undefined;
        }

        let rows = [];
        let mapRow = [];
        let i = 0;
        let selId = this.props.data.selectedId;
        let editId = this.props.data.editId;
        let editadoId = this.props.data.editadoId;

        let empId = 0;
        if (this.props.data.empresas.length > 0) {
            empId = this.props.data.selectEnterpriseId == undefined ? this.props.data.empresas[0].Id : this.props.data.selectEnterpriseId
        }

        let me = this;
        let functions = this.props.data.functions;

        let componenteMostrarMensajeLimitesIguales = null;
        if (this.props.data.estadoMostrarMensajeLimitesIguales) {
            componenteMostrarMensajeLimitesIguales = (<div className="row no-margin-right">
                <div className="col-xs-2"></div>
                <div className="col-xs-10">
                    <label className="label-primary">Este valor ya existe, ingrese otro diferente.</label>
                </div>
            </div>);
        }

        let selec = this.props.selected != undefined ? this.props.selected : false;
        if (this.props.data.cuentas === undefined || this.props.data.cuentas.length === 0)
        {
            rows =
                <div className="row">
                    <div className="col-md-2">
                    </div>
                    <div className="col-md-10">
                        <label className="label-primary">Aun no existen cuentas para ésta empresa</label>
                    </div>
                </div>
        }
        else {
            if (this.props.data.cuentas != undefined) {
                if (functions.Confidencial == true) {
                    rows = this.props.data.cuentas.map(function (row) {
                        return me.createRow(row, novedadCuenta, novedadCuentaEditado, empId, selId, editId, editadoId, editNotifyFn, listNovedadEditado);
                    });
                }
                else {
                    rows = this.props.data.cuentas.map(function (row) {
                        if (row.EsConfidencial == false) {
                            return me.createRow(row, novedadCuenta, novedadCuentaEditado, empId, selId, editId, editadoId, editNotifyFn, listNovedadEditado);
                        }
                        else {
                            return null;
                        }
                    });
                }

                rows.map(function (row) {
                    if (rows[i] != undefined) {
                        mapRow.push(rows[i]);
                    }
                    i += 1;
                });

                if (mapRow[0] === undefined) {
                    rows =
                        <div className="row">
                            <div className="col-md-2">
                            </div>
                            <div className="col-md-10">
                                <label className="label-primary">Aun no existen cuentas para ésta empresa</label>
                            </div>
                        </div>
                }

            }
        }
        return (
            <div>
                {componenteMostrarMensajeLimitesIguales}
                {rows}
            </div>
        );
    }
});

export default TableBody